export function countNumbersInString(s: string): number {
  return (s.match(/\d/g) || []).length;
}
